import { render, staticRenderFns } from "./ParticipantClaimsWidget.vue?vue&type=template&id=3d9bcfca"
import script from "./ParticipantClaimsWidget.vue?vue&type=script&lang=js"
export * from "./ParticipantClaimsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports